import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function NormsTab({ inst, normByDim, setNorm }) {
  return (
    <div className="p-6 rounded-2xl border border-border bg-card space-y-3">
      <div className="text-sm text-muted-foreground">Set mean & standard deviation per dimension to enable z-score and T-score (T = 50 + 10z).</div>
      {inst.dimensions.map((d) => {
        const n = normByDim.get(d.id) || { mean: 0, sd: 1 };
        return (
          <div key={d.id} className="grid grid-cols-12 gap-2 items-center" data-testid={`norm-row-${d.code}`}>
            <div className="col-span-4 font-medium">{d.name_id || d.code}</div>
            <div className="col-span-3"><Label className="text-xs">Mean</Label><Input type="number" value={n.mean ?? 0} onChange={(e) => setNorm(d.id, { mean: parseFloat(e.target.value) || 0 })} data-testid={`norm-mean-${d.code}`} /></div>
            <div className="col-span-3"><Label className="text-xs">SD</Label><Input type="number" value={n.sd ?? 1} onChange={(e) => setNorm(d.id, { sd: parseFloat(e.target.value) || 0 })} data-testid={`norm-sd-${d.code}`} /></div>
          </div>
        );
      })}
    </div>
  );
}
